import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';

export const planyTerapiiService = {
    getPlany,
    createPlan,
    getPlanTerapiiCel,
    updatePlan,
    createPlanTerapiiCel,
    updatePlanTerapiiCel,
    getPlanTerapiiZadanie,
    createPlanterapiiZadanie,
    updatePlanTerapiiZadanie,
    getPlanTerapiiPrint
};

function getPlany(data)
{
    return axios.get('/api/services/app/PlanyTerapiiZdrowienia/GetAll', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function createPlan(data)
{
    return axios.post('/api/services/app/PlanyTerapiiZdrowienia/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updatePlan(data)
{
    return axios.put('/api/services/app/PlanyTerapiiZdrowienia/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })

}
function getPlanTerapiiCel(id)
{
    return axios.get('/api/services/app/PlanyTerapiiZdrowienia/GetPlanTerapiiCel', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {planTerapiiCelId: id}
    })
}
function createPlanTerapiiCel(data)
{
    return axios.post('/api/services/app/PlanyTerapiiZdrowienia/CreatePlanTerapiiCel',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updatePlanTerapiiCel(data)
{
    return axios.put('/api/services/app/PlanyTerapiiZdrowienia/UpdatePlanTerapiiCel',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getPlanTerapiiZadanie(id)
{
    return axios.get('/api/services/app/PlanyTerapiiZdrowienia/GetPlanTerapiiZadanie', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {planTerapiiId: id}
    })
}
function createPlanterapiiZadanie(data)
{
    return axios.post('/api/services/app/PlanyTerapiiZdrowienia/CreatePlanTerapiiZadanie',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updatePlanTerapiiZadanie(data)
{
    return axios.put('/api/services/app/PlanyTerapiiZdrowienia/UpdatePlanTerapiiZadanie',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}

function getPlanTerapiiPrint(id)
{
    return axios.get('/api/services/app/PlanyTerapiiZdrowienia/GetPlanTerapiiPrint', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {planTerapiiId: id}
    })
}